import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { imageUrl } from "../lib/api";

export default function ProductImageGalleryDialog({ open, onOpenChange, name, images = [], startIndex = 0 }) {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(startIndex);

  useEffect(() => {
    if (!api) return;
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    onSelect();
    api.on("select", onSelect);
    return () => api.off("select", onSelect);
  }, [api]);

  useEffect(() => {
    if (!api || !open) return;
    api.scrollTo(startIndex, true);
    setCurrent(startIndex);
  }, [api, open, startIndex]);

  if (!images.length) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[calc(100%-2rem)] p-4 sm:p-6 border-0 bg-neutral-950 text-white shadow-2xl">
        <DialogTitle className="font-display text-lg font-semibold pr-8 truncate">{name}</DialogTitle>

        <Carousel
          setApi={setApi}
          opts={{ startIndex, loop: images.length > 1 }}
          className="w-full"
        >
          <CarouselContent className="-ml-2">
            {images.map((src, i) => (
              <CarouselItem key={`${src}-${i}`} className="pl-2">
                <div className="flex items-center justify-center min-h-[50vh] max-h-[70vh]">
                  <img
                    src={imageUrl(src)}
                    alt={`${name} — image ${i + 1}`}
                    className="max-h-[70vh] w-full object-contain rounded-md"
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          {images.length > 1 && (
            <>
              <CarouselPrevious
                className="left-2 top-1/2 -translate-y-1/2 border-white/20 bg-black/60 text-white hover:bg-black/80 hover:text-white"
              />
              <CarouselNext
                className="right-2 top-1/2 -translate-y-1/2 border-white/20 bg-black/60 text-white hover:bg-black/80 hover:text-white"
              />
            </>
          )}
        </Carousel>

        {images.length > 1 && (
          <>
            <p className="text-center text-xs text-white/60">
              {current + 1} / {images.length}
            </p>
            <div className="flex gap-2 overflow-x-auto pb-1 justify-center">
              {images.map((src, i) => (
                <button
                  key={`thumb-${src}-${i}`}
                  type="button"
                  onClick={() => api?.scrollTo(i)}
                  className="shrink-0 rounded-md overflow-hidden border-2 transition-opacity"
                  style={{
                    borderColor: i === current ? "white" : "transparent",
                    opacity: i === current ? 1 : 0.55,
                  }}
                  aria-label={`View image ${i + 1}`}
                >
                  <img src={imageUrl(src)} alt="" className="w-14 h-14 object-cover" />
                </button>
              ))}
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
